module.exports = __webpack_public_path__ + "static/audi-add3d7ddb41794f476c158d0c993b3ee.gif";